export default [
  {
    name: 'Content.Sites',
    path: 'sites',
    component: () => import('./components/sites/List'),
  },
  {
    name: 'Content.Sites.Edit',
    path: 'sites/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/sites/Edit'),
  },
  {
    name: 'Content.News.List',
    path: 'news',
    component: () => import('./components/news/List'),
  },
  {
    name: 'Content.News.Edit',
    path: 'news/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/news/Edit'),
  },
  {
    name: 'Content.Infrastructure.Edit',
    path: 'infrastructure',
    component: () => import('./components/infrastructure/Edit'),
  },
  {
    name: 'Content.Gallery.List',
    path: 'gallery',
    component: () => import('./components/gallery/List'),
  },
  {
    name: 'Content.Gallery.Edit',
    path: 'gallery/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/gallery/Edit'),
  },
  {
    name: 'Content.SiteTree.List',
    path: 'sitetree',
    component: () => import('./components/sitetree/Tree'),
  },
  {
    name: 'Content.SiteTree.Edit',
    path: 'sitetree/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/sitetree/Edit'),
  },
  {
    name: 'Content.Actions.List',
    path: 'actions',
    component: () => import('./components/actions/List'),
  },
  {
    name: 'Content.Actions.Edit',
    path: 'actions/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/actions/Edit'),
  },
  {
    name: 'Content.Banners.List',
    path: 'banners',
    component: () => import('./components/banners/List'),
  },
  {
    name: 'Content.Banners.Edit',
    path: 'banners/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/banners/Edit'),
  },
  {
    name: 'Content.SocialGallery.List',
    path: 'socialgallery',
    component: () => import('./components/socialgallery/List'),
  },
  {
    name: 'Content.SocialGallery.Edit',
    path: 'socialgallery/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/socialgallery/Edit'),
  },
  {
    name: 'Content.Scripts',
    path: 'scripts',
    component: () => import('./components/scripts/List'),
  },
  {
    name: 'Content.Scripts.Edit',
    path: 'scripts/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/scripts/Edit'),
  },
]
